import PropTypes from 'prop-types';
import textStyles from 'config/branding/textStyles';
import media from '@activebrands/core-web/config/media';
import overlay from '@activebrands/core-web/libs/overlay';
import RichText, { RichTextPropType } from '@activebrands/core-web/libs/storyblok/RichText';
import { styled, useStyletron } from '@activebrands/core-web/libs/styletron';
import { SIGN_IN, SIGN_UP_STEP_ONE } from 'components/auth/UnauthenticatedOverlay';
import ThemeButton, { ButtonsWrapper } from 'components/buttons/ThemeButton';

const InnerWrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '12px',

    [media.min['desktop.sm']]: {
        flexDirection: 'row',
    },
});

const UnAuthenticatedContent = ({ $style, loginButton, loginParagraph, signUpButton }) => {
    const [css] = useStyletron();

    return (
        <div className={css($style)}>
            <InnerWrapper>
                <div className={css({ width: ['100%', null, null, null, '50%'], ...textStyles['Secondary/14_130'] })}>
                    <RichText data={loginParagraph} />
                </div>
                <ButtonsWrapper
                    $style={{
                        display: 'flex',
                        justifyContent: 'flex-stretch',
                        gap: '4px',
                        width: '100%',
                        marginTop: '12px',

                        [media.min['desktop.sm']]: {
                            width: '50%',
                            justifyContent: 'flex-end',
                            marginTop: '0',
                        },
                    }}
                >
                    {loginButton && (
                        <ThemeButton
                            $style={{ flexShrink: 1, width: ['50%', null, null, null, 'auto'] }}
                            fontKeys="Misc/14_110_-2"
                            theme={loginButton.theme}
                            onClick={() => {
                                overlay.open('unauthenticated', {
                                    form: SIGN_IN,
                                    redirect: false,
                                });
                            }}
                        >
                            {loginButton.label}
                        </ThemeButton>
                    )}
                    {signUpButton && (
                        <ThemeButton
                            $style={{ flexShrink: 1, width: ['50%', null, null, null, 'auto'] }}
                            fontKeys="Misc/14_110_-2"
                            theme={signUpButton.theme}
                            onClick={() => {
                                overlay.open('unauthenticated', {
                                    form: SIGN_UP_STEP_ONE,
                                    resetId: 'new-member',
                                });
                            }}
                        >
                            {signUpButton.label}
                        </ThemeButton>
                    )}
                </ButtonsWrapper>
            </InnerWrapper>
        </div>
    );
};

UnAuthenticatedContent.propTypes = {
    $style: PropTypes.object,
    loginButton: PropTypes.shape({
        label: PropTypes.string,
        theme: PropTypes.string,
    }),
    loginParagraph: RichTextPropType,
    signUpButton: PropTypes.shape({
        label: PropTypes.string,
        theme: PropTypes.string,
    }),
};

export default UnAuthenticatedContent;
